// extracted by mini-css-extract-plugin
export var errorIcon = "_la-1";
export var nameLogo = "_la-0";